// extracted by mini-css-extract-plugin
module.exports = {"kit-parts-card__btn":"kit-parts-cards_kit-parts-card__btn___qWHQ","kit-no-text__para":"kit-parts-cards_kit-no-text__para__QmtA4"};